import mainApi from "./mainApi";

const courseApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyCourses: builder.query({
      query: () => {
        return `/api/course/my_course_list`;
      },
      providesTags: ["courses"],
    }),
    getMyAllCourses: builder.query({
      query: () => {
        return `/api/course/my_course_list/all_course`;
      },
      providesTags: ["courses"],
    }),
    //Course Api
    getBatches: builder.query({
      query: () => {
        return `/api/course/batch_list`;
      },
    }),
    getCourses: builder.query({
      query: (page = 1) => {
        return `/api/course/course/?page=${page}`;
      },
      providesTags: ["courses"],
    }),
    getAllCourses: builder.query({
      query: ({ search } = {}) => {
        let url = `/api/course/course/all-courses`;
        if (search) {
          url += `?search=${encodeURIComponent(search)}`;
        }
        return url;
      },
      providesTags: ["courses"],
    }),
    getCoursesAdmin: builder.query({
      query: ({ page = 1 }) => `/api/course/admin/course/?page=${page}`,
      providesTags: ["courses"],
    }),
    getAllCoursesAdmin: builder.query({
      query: () => `/api/course/admin/course/all-course`,
      providesTags: ["courses"],
    }),
    getSingleCourseByID: builder.query({
      query: (id) => {
        return `/api/course/course/${id}/`;
      },
      providesTags: ["courses"],
    }),
    getSingleCourseBySlug: builder.query({
      query: (slug) => {
        return `/api/course/course_detail/${slug}`;
      },
      providesTags: ["courses"],
    }),
    getSingleCourseAdmin: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/`;
      },
      providesTags: ["courses"],
    }),
    createCourse: builder.mutation({
      query: (courseData) => ({
        url: `/api/course/admin/course/`, // Ensure this is the correct endpoint
        method: "POST",
        body: courseData,
        formData: true, // Make sure RTK Query knows it's FormData
      }),
      invalidatesTags: ["courses"],
    }),
    updateCourse: builder.mutation({
      query: ({ courseData, id }) => ({
        url: `/api/course/admin/course/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: courseData,
      }),
      invalidatesTags: ["courses"],
    }),
    deleteCourse: builder.mutation({
      query: (id) => ({
        url: `/api/course/admin/course/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["courses"],
    }),

    //Section Api
    getSections: builder.query({
      query: (course_id) => {
        return `/api/course/admin/${course_id}/section/`;
      },
      providesTags: ["sections"],
    }),
    getSectionById: builder.query({
      query: ({ course_id, id }) => {
        return `/api/course/admin/${course_id}/section/${id}/`;
      },
      providesTags: ["sections"],
    }),
    createSection: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/${id}/section/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["sections"],
    }),
    updateSection: builder.mutation({
      query: ({ sectionData, id, course_id }) => ({
        url: `/api/course/admin/${course_id}/section/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: sectionData,
      }),
      invalidatesTags: ["sections"],
    }),
    deleteSection: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/${course_id}/section/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["sections"],
    }),

    //Lecture Api
    getLectures: builder.query({
      query: () => {
        return `/api/course/admin/course_lecture/`;
      },
      providesTags: ["lectures"],
    }),
    getLecturesByCourseId: builder.query({
      query: (courseId) => {
        return `/api/course/admin/course_lecture/?course=${courseId}`;
      },
      providesTags: ["lectures"],
    }),
    createLecture: builder.mutation({
      query: (formData) => ({
        url: `/api/course/admin/course_lecture/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["lectures"],
    }),
    updateLecture: builder.mutation({
      query: ({ lectureData, id }) => ({
        url: `/api/course/admin/course_lecture/${id}/`,
        method: "PUT",
        body: JSON.stringify(lectureData),
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["lectures"],
    }),

    deleteLEcture: builder.mutation({
      query: ({ id }) => ({
        url: `/api/course/admin/course_lecture/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["lectures"],
    }),
    // Lecture Item API
    getLectureItems: builder.query({
      query: (lecture_id) => {
        return `/api/course/admin/${lecture_id}/lecture_item/`;
      },
      providesTags: ["lectures"],
    }),
    getLectureItemsByCourse: builder.query({
      query: (course_id) => {
        return `/api/course/admin/course/${course_id}/lecture_item_by_course/`;
      },
      providesTags: ["lectures"],
    }),
    createLectureItem: builder.mutation({
      query: ({ formData, lecture_id }) => ({
        url: `/api/course/admin/course/${lecture_id}/lecture_item/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["lectures"],
    }),
    updateLectureItem: builder.mutation({
      query: ({ lectureData, id, lecture_id }) => ({
        url: `/api/course/admin/course/${lecture_id}/lecture_item/${id}/`, // Ensure this is the correct endpoint
        method: "PUT",
        body: lectureData,
      }),
      invalidatesTags: ["lectures"],
    }),
    deleteLectureItem: builder.mutation({
      query: ({ lecture_id, id }) => ({
        url: `/api/course/admin/course/${lecture_id}/lecture_item/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["lectures"],
    }),

    //Mentor Api
    getMentors: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_mentor/`;
      },
      providesTags: ["mentors"],
    }),
    getMentorComments: builder.query({
      query: ({ start_date = "", end_date = "" } = {}) => {
        const params = new URLSearchParams();
        if (start_date) params.append("start_date", start_date);
        if (end_date) params.append("end_date", end_date);
        return `/api/post/mentor_table/?${params.toString()}`;
      },
      providesTags: ["mentors"],
    }),
    createMentor: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_mentor/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["mentors"],
    }),
    updateMentor: builder.mutation({
      query: ({ mentorData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_mentor/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: mentorData,
      }),
      invalidatesTags: ["mentors"],
    }),
    deleteMentor: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_mentor/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["mentors"],
    }),

    //Routine Api
    getRoutines: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_routine/`;
      },
      providesTags: ["routines"],
    }),
    createRoutine: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_routine/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["routines"],
    }),
    updateRoutine: builder.mutation({
      query: ({ routineData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_routine/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: routineData,
      }),
      invalidatesTags: ["routines"],
    }),
    deleteRoutine: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_routine/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["routines"],
    }),

    //Course Prep Api
    getCoursePreps: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_prep/`;
      },
      providesTags: ["preps"],
    }),
    createCoursePrep: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_prep/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["preps"],
    }),
    updateCoursePrep: builder.mutation({
      query: ({ prepData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_prep/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: prepData,
      }),
      invalidatesTags: ["preps"],
    }),
    deleteCoursePrep: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_prep/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["preps"],
    }),

    //Course Details Api
    getCourseDescriptions: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_description/`;
      },
      providesTags: ["descriptions"],
    }),
    createCourseDescription: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_description/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["descriptions"],
    }),
    updateCourseDescription: builder.mutation({
      query: ({ descriptionData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_description/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: descriptionData,
      }),
      invalidatesTags: ["descriptions"],
    }),
    deleteCourseDescription: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_description/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["descriptions"],
    }),

    //Course Description Videos Api
    getDescriptionVideos: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_description_video/`;
      },
      providesTags: ["videos"],
    }),
    createDescriptionVideo: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_description_video/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["videos"],
    }),
    updateDescriptionVideo: builder.mutation({
      query: ({ videoData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_description_video/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: videoData,
      }),
      invalidatesTags: ["videos"],
    }),
    deleteDescriptionVideo: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_description_video/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["videos"],
    }),

    //Course Update Photos Api
    getUpdatePhotos: builder.query({
      query: (id) => {
        return `/api/course/admin/course/${id}/course_image/`;
      },
      providesTags: ["update_photos"],
    }),
    createUpdatePhoto: builder.mutation({
      query: ({ formData, id }) => ({
        url: `/api/course/admin/course/${id}/course_image/`, // Ensure this is the correct endpoint
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["update_photos"],
    }),
    updateUpdatePhoto: builder.mutation({
      query: ({ photoData, id, course_id }) => ({
        url: `/api/course/admin/course/${course_id}/course_image/${id}/`, // Ensure this is the correct endpoint
        method: "PATCH",
        body: photoData,
      }),
      invalidatesTags: ["update_photos"],
    }),
    deleteUpdatePhoto: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_image/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["update_photos"],
    }),
    //comments
    submitComment: builder.mutation({
      query: (data) => {
        return {
          method: "POST",
          url: "api/post/submit_comment",
          body: data,
        };
      },
      invalidatesTags: ["posts"],
    }),
    deleteComment: builder.mutation({
      query: (comment_id) => {
        return {
          method: "DELETE",
          url: `api/post/comment/${comment_id}/`,
        };
      },
      invalidatesTags: ["posts"],
    }),
    updateComment: builder.mutation({
      query: ({ comment_id, data }) => {
        return {
          method: "PATCH",
          url: `api/post/comment/${comment_id}/`,
          body: data,
        };
      },
      invalidatesTags: ["posts"],
    }),
    //post
    createPost: builder.mutation({
      query: (data) => {
        return {
          method: "POST",
          url: "api/post/post/",
          body: data,
        };
      },
      invalidatesTags: ["posts"],
    }),
    deletePost: builder.mutation({
      query: (postId) => ({
        method: "DELETE",
        url: `api/post/post/${postId}/`,
      }),
      invalidatesTags: ["posts"],
    }),

    //post locking endpoints
    checkPostLock: builder.query({
      query: (postId) => ({
        url: `/api/post/lock_post/${postId}`,
      }),
    }),
    lockPost: builder.mutation({
      query: (postId) => ({
        url: `/api/post/lock_post/${postId}`,
        method: "POST",
      }),
    }),

    getCourseGifts: builder.query({
      query: (courseId) => `/api/course/admin/course/${courseId}/course_gift/`,
      providesTags: (result, error, courseId) => [{ type: "CourseGifts", id: courseId }],
    }),

    // Create a new Course Gift
    createCourseGift: builder.mutation({
      query: ({ courseId, giftData }) => ({
        url: `/api/course/admin/course/${courseId}/course_gift/`,
        method: "POST",
        body: giftData,
      }),
      invalidatesTags: (result, error, { courseId }) => [{ type: "CourseGifts", id: courseId }],
    }),

    // Delete a Course Gift
    deleteCourseGift: builder.mutation({
      query: ({ course_id, id }) => ({
        url: `/api/course/admin/course/${course_id}/course_gift/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CourseGifts"], // Refresh all gifts after deletion
    }),

    // get organization data
    getOrganizationData: builder.query({
      query: () => {
        return `/api/account/organization`;
      },
      providesTags: ["Organization"],
    }),

    // get course question data
    getCourseQuestionData: builder.query({
      query: () => {
        return `/api/course/course_question/`;
      },
      providesTags: ["CourseQuestion"],
    }),
    // get form ans data
    getFormAnswerData: builder.query({
      query: ({ course_id, searchValue, page }) => {
        return `/api/course/admin/user_course_question/?course_id=${course_id}&search=${searchValue}&page=${page} `;
      },
      providesTags: ["FormAnswer"],
    }),

    //update form answer
    updateFormAnswer: builder.mutation({
      query: (data) => ({
        url: `/api/course/admin/user_form_question/${data?.id}/`,
        method: "PATCH",
        body: {
          answer: data.answer,
        },
      }),
      invalidatesTags: ["FormAnswer"],
    }),

    // get form qeustion data
    getFormQuestionData: builder.query({
      query: () => {
        return `/api/course/course_question/ `;
      },
      providesTags: ["FormQuestion"],
    }),

    //create form question

    createFormQuestion: builder.mutation({
      query: (data) => ({
        url: `/api/course/course_question/`,
        method: "POST",
        body: {
          question: data.question,
        },
      }),
      invalidatesTags: ["FormQuestion"],
    }),

    //update form question

    updateFormQuestion: builder.mutation({
      query: (data) => ({
        url: `/api/course/course_question/${data.id}/`,
        method: "PATCH",
        body: {
          question: data.question,
        },
      }),
      invalidatesTags: ["FormQuestion"],
    }),

    // delete form question
    deleteFormQuestion: builder.mutation({
      query: (id) => ({
        url: `/api/course/course_question/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["FormQuestion"],
    }),

    // get prebooking data

    getPrebookingList: builder.query({
      query: ({ course_id, searchValue, page }) => {
        return `/api/course/admin/user_prebooking_list?page=${page}&search=${searchValue}&course_id=${course_id}`;
      },
      providesTags: ['PrebookingAnswer'],
    }),

    // get prebooking questions

    getPrebookingQuestions: builder.query({
      query: () => {
        return `/api/course/admin/prebooking_question/ `;
      },
      providesTags: ['PrebookingQuestion'],
    }),

    // POST: Create a new prebooking question
    createPrebookingQuestion: builder.mutation({
      query: (data) => ({
        url: '/api/course/admin/prebooking_question/',
        method: 'POST',
        body: {
          question: data.question,
        },
      }),
      invalidatesTags: ['PrebookingQuestion'],
    }),

    // PATCH: Update an existing prebooking question
    updatePrebookingQuestion: builder.mutation({
      query: (data) => ({
        url: `/api/course/admin/prebooking_question/${data.id}/`,
        method: 'PATCH',
        body: {
          question: data.question,
        },
      }),
      invalidatesTags: ['PrebookingQuestion'],
    }),

    // DELETE: Delete a prebooking question
    deletePrebookingQuestion: builder.mutation({
      query: (id) => ({
        url: `/api/course/admin/prebooking_question/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['PrebookingQuestion'],
    }),


  }),
});

export const {
  useGetMyCoursesQuery,
  useGetMyAllCoursesQuery,
  useGetBatchesQuery,
  useGetCoursesQuery,
  useGetAllCoursesQuery,
  useGetSingleCourseByIDQuery,
  useGetSingleCourseBySlugQuery,
  useCreateCourseMutation,
  useUpdateCourseMutation,
  useDeleteCourseMutation,
  useGetSectionsQuery,
  useGetSectionByIdQuery,
  useCreateSectionMutation,
  useUpdateSectionMutation,
  useDeleteSectionMutation,
  useCreateLectureMutation,
  useGetLecturesQuery,
  useGetLecturesByCourseIdQuery,
  useUpdateLectureMutation,
  useDeleteLEctureMutation,
  useGetLectureItemsQuery,
  useGetLectureItemsByCourseQuery,
  useCreateLectureItemMutation,
  useUpdateLectureItemMutation,
  useDeleteLectureItemMutation,
  useGetMentorsQuery,
  useCreateMentorMutation,
  useUpdateMentorMutation,
  useDeleteMentorMutation,
  useGetRoutinesQuery,
  useCreateRoutineMutation,
  useUpdateRoutineMutation,
  useDeleteRoutineMutation,
  useGetCoursePrepsQuery,
  useCreateCoursePrepMutation,
  useUpdateCoursePrepMutation,
  useDeleteCoursePrepMutation,
  useGetCourseDescriptionsQuery,
  useCreateCourseDescriptionMutation,
  useUpdateCourseDescriptionMutation,
  useDeleteCourseDescriptionMutation,
  useGetDescriptionVideosQuery,
  useCreateDescriptionVideoMutation,
  useUpdateDescriptionVideoMutation,
  useDeleteDescriptionVideoMutation,
  useGetUpdatePhotosQuery,
  useCreateUpdatePhotoMutation,
  useUpdateUpdatePhotoMutation,
  useDeleteUpdatePhotoMutation,
  useGetCoursesAdminQuery,
  useGetAllCoursesAdminQuery,
  useGetSingleCourseAdminQuery,
  useSubmitCommentMutation,
  useDeleteCommentMutation,
  useUpdateCommentMutation,
  useCreatePostMutation,
  useDeletePostMutation,
  useGetCourseGiftsQuery,
  useCreateCourseGiftMutation,
  useDeleteCourseGiftMutation,
  useGetOrganizationDataQuery,
  useGetCourseQuestionDataQuery,
  useGetFormAnswerDataQuery,
  useGetFormQuestionDataQuery,
  useCreateFormQuestionMutation,
  useUpdateFormQuestionMutation,
  useDeleteFormQuestionMutation,
  useGetPrebookingQuestionsQuery,
  useCreatePrebookingQuestionMutation,
  useUpdatePrebookingQuestionMutation,
  useDeletePrebookingQuestionMutation,
  useGetPrebookingListQuery,
  useUpdateFormAnswerMutation,
  useCheckPostLockQuery,
  useLockPostMutation,
  useGetMentorCommentsQuery,
} = courseApi;
